export function getAvatar(crm_id): string {
    const baseUrl = 'https://d1ac9zce9817ms.cloudfront.net/images/icons';

    const number = parseInt(String(String(crm_id).split('').map(s => s.charCodeAt(0)).reduce((a, b) => a + b, 0) % 15), 10);

    return baseUrl + String(number) + '.svg';
}
